import React from 'react';
import DatePicker from 'react-datepicker';
import {Form, Input, Button, Select} from 'semantic-ui-react';
import {dateFormatPicker} from '../../../common/constants/datesFormat';

const typesOptions = [
  {'key': 'TODOS', 'text': 'TODOS', 'value': 'TODOS'},
  {'key': 'TMC', 'text': 'TMC', 'value': 'TMC'},
  {'key': 'SERVICIO', 'text': 'SERVICIO', 'value': 'SERVICIO'},
];

const SearchFormMany = ({
  handleSearch,
  handleClear,
  handleChange,
  initDate,
  endDate,
  bulletinId,
  model,
  subject,
  type,
}) => {
  const validateManySearch = !initDate || !endDate;

  return (
    <Form>
      <label className='label-group'>Parámetros de boletines:</label>
      <Form.Group widths='4'>
        <Form.Input fluid label='Fecha de inicial'>
          <DatePicker
            placeholderText='Fecha de inicial'
            className='tcc-datepicker'
            showYearDropdown
            selected={initDate}
            dateFormat={dateFormatPicker}
            onChange={(value) => handleChange('initDate', value)}
            locale='es'
            required
          />
        </Form.Input>
        <Form.Input fluid label='Fecha de final'>
          <DatePicker
            placeholderText='Fecha de final'
            className='tcc-datepicker'
            showYearDropdown
            selected={endDate}
            dateFormat={dateFormatPicker}
            minDate={initDate}
            onChange={(value) => handleChange('endDate', value)}
            locale='es'
            required
          />
        </Form.Input>
        <Form.Field
          control={Select}
          label='Tipo de boletin'
          placeholder='Tipo de boletin'
          value={type}
          options={typesOptions}
          onChange={(e, {value}) => handleChange('type', value)}
        />
      </Form.Group>
      <Form.Group widths='4'>
        <Form.Field
          control={Input}
          label='Código del boletin'
          placeholder='Código del boletin'
          value={bulletinId}
          onChange={(e, {value}) => handleChange('bulletinId', value.toUpperCase())}
        />
        <Form.Field
          control={Input}
          label='Modelo'
          placeholder='Modelo'
          value={model}
          onChange={(e, {value}) => handleChange('model', value.toUpperCase())}
        />
        <Form.Field
          control={Input}
          label='Asunto'
          placeholder='Asunto'
          value={subject}
          onChange={(e, {value}) => handleChange('subject', value)}
        />
        <div className='form-buttons'>
          <Button onClick={handleClear} secondary>
            Limpiar
          </Button>
          <Button
            disabled={validateManySearch}
            onClick={handleSearch}
            type='submit'
            primary
          >
            Buscar
          </Button>
        </div>
      </Form.Group>
    </Form>
  );
};

export default SearchFormMany;
